module.exports = __webpack_public_path__ + "media/slot-game/soup-93f60c9d.svg";